var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(-1027 -1652)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(1027 1652)",
    fill: "#e5eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "personality",
    transform: "translate(1033.684 1658.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940",
    transform: "translate(54.085 30.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M122.77,59.6h3.9v50.952h-3.9Z",
    transform: "translate(-122.77 -59.603)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    transform: "translate(32.993 41.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M112.224,92.646l-8.879,5.123L93.084,103.7l-1.953,1.125-1.948,1.125-1.948,1.125-13.012,7.513L68.1,118.122l-1.953-3.375,6.9-3.984L85.283,103.7l1.953-1.125,1.948-1.125,1.948-1.125,9.842-5.681,9.3-5.37Z",
    transform: "translate(-66.144 -89.271)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942",
    transform: "translate(32.993 41.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M112.224,114.747l-1.953,3.375-6.127-3.538-13.012-7.513-1.948-1.125-1.948-1.125L85.283,103.7l-10.26-5.927-8.879-5.123L68.1,89.271l9.3,5.37,9.842,5.681,1.948,1.125,1.948,1.125,1.953,1.125,12.236,7.066Z",
    transform: "translate(-66.144 -89.271)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951",
    transform: "translate(45.343 12.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    fill: "#69d2c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(0 64.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    fill: "#207bbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960",
    transform: "translate(13.317 27.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954",
    transform: "translate(0 29.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    transform: "translate(4.009 4.009)",
    fill: "#69d2c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958",
    transform: "translate(59.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1956",
    "data-name": "Group 1956",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    transform: "translate(1.005 1.005)",
    fill: "#207bbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969",
    transform: "translate(13.437 24.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963",
    transform: "translate(59.11 35.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1962",
    "data-name": "Group 1962",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    transform: "translate(0.791 0.791)",
    fill: "#69d2c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 10.69,
    cy: 10.69,
    r: 10.69,
    transform: "translate(3.934 3.934)",
    fill: "#207bbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972",
    transform: "translate(22.611 33.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970",
    transform: "translate(4.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M51,79.816A1.117,1.117,0,0,1,49.878,78.7V70.051a1.117,1.117,0,1,1,2.235,0V78.7A1.117,1.117,0,0,1,51,79.816Z",
    transform: "translate(-49.878 -68.934)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(0 4.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M48.035,82.777H39.388a1.117,1.117,0,1,1,0-2.235h8.647a1.117,1.117,0,1,1,0,2.235Z",
    transform: "translate(-38.271 -80.542)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973",
    transform: "translate(79.17 67.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M197.109,158.98a2.689,2.689,0,0,0-1.968.853.246.246,0,0,1-.359,0,2.7,2.7,0,0,0-4.664,1.844c0,2.229,3.436,5.45,4.521,6.411a.488.488,0,0,0,.647,0c1.084-.961,4.521-4.182,4.521-6.411A2.7,2.7,0,0,0,197.109,158.98Z",
    transform: "translate(-190.117 -158.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979",
    transform: "translate(77.862 33.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1974",
    "data-name": "Group 1974",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 6.152,
    cy: 6.152,
    r: 6.152,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976",
    transform: "translate(2.975 7.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1975",
    "data-name": "Group 1975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M200.342,87.261a.6.6,0,0,1,.589.74,3.247,3.247,0,0,1-6.323,0,.6.6,0,0,1,.589-.74Z",
    transform: "translate(-194.592 -87.261)",
    fill: "#414042"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977",
    transform: "translate(2.471 3.534)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 0.876,
    cy: 0.876,
    r: 0.876,
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978",
    transform: "translate(8.015 3.534)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 0.876,
    cy: 0.876,
    r: 0.876,
    fill: "#414042"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983",
    transform: "translate(21.235 66.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980",
    transform: "translate(4.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M51.206,161.383c0,2.657-2.442,4.811-2.442,4.811s-2.442-2.154-2.442-4.811,2.442-4.811,2.442-4.811S51.206,158.726,51.206,161.383Z",
    transform: "translate(-46.321 -156.572)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981",
    transform: "translate(0 2.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M38.951,166.109a4.594,4.594,0,0,1,.088-.879,8.081,8.081,0,0,0-4.456-1.121s-.2,3.25,1.675,5.129,5.113,1.676,5.128,1.675C41.241,170.783,38.951,168.682,38.951,166.109Z",
    transform: "translate(-34.577 -164.103)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    transform: "translate(6.824 2.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M59.7,164.11a8.081,8.081,0,0,0-4.456,1.121,4.591,4.591,0,0,1,.088.879c0,2.573-2.291,4.674-2.435,4.8.016,0,3.254.2,5.128-1.675S59.7,164.11,59.7,164.11Z",
    transform: "translate(-52.897 -164.104)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(38.137 37.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 17.896,
    cy: 17.896,
    r: 17.896,
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(4.89 2.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(0 22.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M119.094,151.935a17.9,17.9,0,0,1-26.011,0,7.458,7.458,0,0,1,7.166-5.386h11.677A7.459,7.459,0,0,1,119.094,151.935Z",
    transform: "translate(-93.083 -146.549)",
    fill: "#463b83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997",
    transform: "translate(4.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    transform: "translate(6.787 18.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M122.246,135.813v5.3a2.143,2.143,0,0,0,4.286,0v-5.3Z",
    transform: "translate(-122.246 -135.813)",
    fill: "#f2ad97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991",
    transform: "translate(2.176 2.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M116.62,110.034a6.755,6.755,0,0,1-6.754-6.754V99.773a6.754,6.754,0,0,1,13.509,0v3.506A6.755,6.755,0,0,1,116.62,110.034Z",
    transform: "translate(-109.866 -93.019)",
    fill: "#fcc4ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992",
    transform: "translate(0 10.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M106.2,117.01V114.9a2.176,2.176,0,1,0,.371,4.317A6.74,6.74,0,0,1,106.2,117.01Z",
    transform: "translate(-104.025 -114.899)",
    fill: "#fcc4ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993",
    transform: "translate(15.314 10.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M145.51,114.9v2.111a6.744,6.744,0,0,1-.371,2.207,2.175,2.175,0,1,0,.371-4.318Z",
    transform: "translate(-145.139 -114.899)",
    fill: "#fcc4ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994",
    transform: "translate(0.054 0.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M110.6,88.2a9.666,9.666,0,0,1-5.049,8.491.931.931,0,0,1-1.374-.887,9.833,9.833,0,0,1,3.064-6.371,8.819,8.819,0,0,1,3.331-1.944C110.587,87.721,110.6,87.957,110.6,88.2Z",
    transform: "translate(-104.17 -87.486)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995",
    transform: "translate(3.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M126.539,95.435a9.927,9.927,0,0,1-14.131-6.666,8.826,8.826,0,0,1,3.309-1.937c5.264-1.709,10.51,2.3,11.309,7.651A.923.923,0,0,1,126.539,95.435Z",
    transform: "translate(-112.408 -86.432)",
    fill: "#414042"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006",
    transform: "translate(5.991 21.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003",
    transform: "translate(2.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M124.7,144.518l-4.043,10.969c-.26.011-.519.019-.779.019s-.519-.007-.779-.019l-4.039-10.969,2.667-1.206v1.157l2.151,3.35,2.151-3.35v-1.157Z",
    transform: "translate(-115.064 -143.312)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M115.062,144.517l2.013,5.46a.324.324,0,0,0,.534.117l2.272-2.273-2.15-3.351v-1.158Z",
    transform: "translate(-115.062 -143.312)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000",
    transform: "translate(4.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M132.821,144.516l-2.014,5.46a.324.324,0,0,1-.534.117L128,147.82l2.15-3.351v-1.158Z",
    transform: "translate(-128 -143.311)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(3.02 4.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M126.768,157.216l-1.341,1.341a.649.649,0,0,1-.917,0l-1.341-1.341,1.8-1.8Z",
    transform: "translate(-123.169 -155.416)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002",
    transform: "translate(3.502 7.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M127.1,166.133l-.538,1.465c-.26.011-.519.019-.779.019s-.519-.007-.779-.019l-.538-1.465.4-3.52.46.46a.654.654,0,0,0,.92,0l.46-.46Z",
    transform: "translate(-124.465 -162.613)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    transform: "translate(0 1.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M115.4,157.518c-.426-.015-.846-.048-1.261-.1l-4.329-4.689a.317.317,0,0,1,.026-.46l1.142-1.009a.326.326,0,0,0-.178-.568l-1.347-.145a.326.326,0,0,1-.271-.434l1.295-3.565h.883Z",
    transform: "translate(-109.167 -146.549)",
    fill: "#463b83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    transform: "translate(7.794 1.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M136.037,150.549l-1.346.145a.326.326,0,0,0-.178.568l1.142,1.009a.318.318,0,0,1,.026.46l-4.329,4.689c-.415.052-.835.085-1.261.1l4.043-10.969h.883l1.291,3.565a.326.326,0,0,1-.271.434Z",
    transform: "translate(-130.091 -146.55)",
    fill: "#463b83"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(49.777 81.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    transform: "translate(1.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M120.731,201.8a3.627,3.627,0,0,1-2.581-1.069l-1.517-1.517a.745.745,0,0,1,1.053-1.053l1.517,1.517a2.16,2.16,0,0,0,3.055,0l1.517-1.517a.745.745,0,0,1,1.053,1.053l-1.517,1.517A3.627,3.627,0,0,1,120.731,201.8Z",
    transform: "translate(-116.415 -197.942)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    transform: "translate(6.718 1.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M137.563,211.79a.742.742,0,0,1-.527-.218l-1.517-1.517a3.65,3.65,0,0,1,0-5.162l1.517-1.517a.745.745,0,0,1,1.053,1.054l-1.517,1.517a2.16,2.16,0,0,0,0,3.054l1.517,1.517a.745.745,0,0,1-.527,1.272Z",
    transform: "translate(-134.451 -203.157)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015",
    transform: "translate(0 1.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(1.944 6.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M124.308,225.05a.742.742,0,0,1-.527-.218l-1.517-1.517a2.163,2.163,0,0,0-3.055,0l-1.517,1.517a.745.745,0,0,1-1.053-1.053l1.517-1.517a3.654,3.654,0,0,1,5.161,0l1.517,1.517a.744.744,0,0,1-.527,1.271Z",
    transform: "translate(-116.421 -221.194)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M111.948,211.787a.745.745,0,0,1-.527-1.272L112.938,209a2.16,2.16,0,0,0,0-3.054l-1.517-1.517a.745.745,0,0,1,1.053-1.053l1.517,1.517a3.65,3.65,0,0,1,0,5.162l-1.517,1.517A.745.745,0,0,1,111.948,211.787Z",
    transform: "translate(-111.203 -203.155)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(50.825 15.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M122.638,24.482a.239.239,0,0,0-.364.063,3.942,3.942,0,0,1-2.144,1.781,3.9,3.9,0,0,0,.473-4.045,6.167,6.167,0,0,0-2.582-2.466.536.536,0,0,0-.781.594,3.647,3.647,0,0,1-1.293,3.984,5.2,5.2,0,1,0,6.692.089Z",
    transform: "translate(-114.016 -19.744)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(4.853 4.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M130.47,33.192a2.876,2.876,0,0,0,.109-.848h0a.235.235,0,0,0-.13.108,3.941,3.941,0,0,1-2.144,1.781l0,0,0,0c-.06.083-.877,1.251-1.236,1.763a.124.124,0,0,0,.03.174A4.23,4.23,0,0,0,130.47,33.192Z",
    transform: "translate(-127.044 -32.343)",
    fill: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(1.129 7.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M125.657,43.9s0-.008,0-.012c-.155.058-.228.184-.368.317a2.584,2.584,0,0,1-4.088-.751.126.126,0,0,0-.237.045,2.606,2.606,0,0,0,.866,2.245.125.125,0,0,1-.1.215,3.651,3.651,0,0,1-2.453-5.479.125.125,0,0,0-.16-.178,3.781,3.781,0,0,0-1.956,4.307h0a5.1,5.1,0,0,0,7.279.727,5,5,0,0,0,1.224-1.436Z",
    transform: "translate(-117.047 -40.29)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(0.022 0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M117.463,20.07a.517.517,0,0,0-.186.544,3.647,3.647,0,0,1-1.293,3.984,5.366,5.366,0,0,0-1.908,3.519,8.956,8.956,0,0,1,2.6-2.344,3.857,3.857,0,0,0,.79-5.7Z",
    transform: "translate(-114.076 -20.07)",
    fill: "#f1f2f2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTwo);
export default __webpack_public_path__ + "static/media/test-two.64f9a4225376b1597a03f5a376830d6d.svg";
export { ForwardRef as ReactComponent };